import { createElement } from "react";
import { Trans } from "react-i18next";
import { put } from "../../../common/api/apiShared";
import { Result } from "../../../common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { DeletionPeriodViewModel } from "../deletionPeriods/DeletionPeriods.types";
import { IChangeDeletionPeriodStatusDialog } from "./ChangeDeletionPeriodStatusDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useChangeDeletionPeriodStatusDialogHooks(props: IChangeDeletionPeriodStatusDialog) {
    const snackbar = useDotLegalSnackbar();

    const changeActiveStatusMutation = useDotLegalMutation(changeStatus);

    const changeActiveStatus = (deletionPeriod: DeletionPeriodViewModel) => {
        changeActiveStatusMutation.mutateAsync(deletionPeriod, {
            onSuccess: (response: Result<string>) => {
                props.onCloseDialog();

                if (response.success()) {
                    snackbar.show(createElement(Trans, { i18nKey: "activeStatusChanged", values: { name: deletionPeriod.name } }));
                    props.refetch();
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "deletionPeriodStatusNotChanged", values: { name: deletionPeriod.name } }), "warning");
                }
            },
        });
    };

    function changeStatus(deletionPeriod: DeletionPeriodViewModel) {
        if (deletionPeriod.isCustom) return put<string>(`/deletion-periods/${deletionPeriod.id}/toggle-active`, !deletionPeriod.active);
        else return put<string>(`/deletion-periods/${deletionPeriod.id}/toggle-master-data-active`, !deletionPeriod.active);
    }

    return {
        changeActiveStatus,
        inProgress: changeActiveStatusMutation.isLoading,
    };
}
